// ─── My Cookbook — Fresh & Modern Palette ─────────────────────────────────────

// Primary sage green
export const sage = {
  dark:    '#2d6a4f',   // deep forest, headers
  mid:     '#4d8b6f',   // primary sage
  light:   '#7db99a',   // soft sage
  pale:    '#e8f5ee',   // very light sage, backgrounds
  faint:   '#f2faf6',   // near-white sage
}

// Neutrals
export const neutral = {
  900: '#111827',  // near-black, primary text
  700: '#374151',  // body text
  500: '#6b7280',  // secondary text
  300: '#d1d5db',  // borders
  100: '#f3f4f6',  // soft backgrounds
  50:  '#f9fafb',  // page background
  0:   '#ffffff',  // pure white
}

// Accent — warm terracotta for alerts, timers, CTAs
export const warm = {
  mid:   '#c0654a',
  light: '#f5e6e1',
  dark:  '#8a3e28',
}

// Gold — used sparingly for stars, premium accents
export const gold = {
  mid:   '#c9a227',
  light: '#f0d878',
  pale:  '#fdf6e3',
}

// ─── Semantic aliases (used throughout components) ─────────────────────────────

// Replaces old "leather" palette — used on sign-in, cover, modals
export const leather = {
  bg:       sage.dark,
  bgHi:     sage.mid,
  bgDeep:   '#1a3328',
  gold:     sage.mid,
  goldLight: '#a8d5bc',
  goldDim:  sage.light,
  goldSheen: '#c8e8d8',
}

// Replaces old "paper" palette — used on recipe pages
export const paper = {
  ink:        neutral[900],
  inkLight:   neutral[700],
  inkFaint:   neutral[500],
  bg:         neutral[50],
  bgDark:     neutral[100],
  bgWhite:    neutral[0],
  borderMed:  neutral[300],
  borderDark: '#9ca3af',
  accentWarm: warm.mid,
  accentWarmDim: warm.dark,
}

// ─── Typography ───────────────────────────────────────────────────────────────
export const fonts = {
  cursive: "'Cormorant Garamond', Georgia, serif",  // elegant display
  serif:   "'Inter', system-ui, sans-serif",          // clean body
  mono:    "'JetBrains Mono', 'Courier New', monospace",
}

// ─── Shadows ──────────────────────────────────────────────────────────────────
export const shadows = {
  book:      '0 20px 60px rgba(0,0,0,0.15), 0 4px 16px rgba(0,0,0,0.08)',
  card:      '0 1px 4px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
  cardHover: '0 8px 24px rgba(0,0,0,0.10), 0 0 0 1px rgba(77,139,111,0.2)',
  sidebar:   '-1px 0 0 rgba(0,0,0,0.06)',
  modal:     '0 24px 64px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)',
  popup:     '0 8px 32px rgba(0,0,0,0.12)',
}

export default { sage, neutral, warm, gold, leather, paper, fonts, shadows }
